if (!customElements.get('size-guide-content')) {
  customElements.define(
    'size-guide-content',
    class SizeGuideContent extends HTMLElement {
      constructor() {
        super();

        // Tabs, the unit toggle and the buy-box DOM refs don't depend on the
        // variants JSON, so they're wired up first and independently: a problem
        // parsing product data should never take down unrelated UI like the
        // "Cómo medir" tab or the cart icon.
        this.initTabs();
        this.initUnitToggle();
        this.initBuyBox();

        try {
          this.variants = JSON.parse(this.querySelector('[data-size-guide-variants]').textContent);
          this.optionPosition = parseInt(this.dataset.optionPosition, 10);
          this.currentVariant = this.findVariantById(this.variantIdInput?.value);
          this.initSizeButtons();
        } catch (error) {
          console.error('size-guide-content: failed to read product variants', error);
        }
      }

      initTabs() {
        this.tabs = this.querySelectorAll('.size-guide__tab');
        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => {
            this.tabs.forEach((otherTab) => {
              otherTab.classList.remove('is-active');
              otherTab.setAttribute('aria-selected', 'false');
            });
            tab.classList.add('is-active');
            tab.setAttribute('aria-selected', 'true');

            this.querySelectorAll('.size-guide__panel').forEach((panel) => {
              panel.hidden = panel.dataset.tabPanel !== tab.dataset.tab;
            });
          });
        });
      }

      initUnitToggle() {
        this.unitButtons = this.querySelectorAll('.size-guide__unit-toggle button');
        this.measurementCells = this.querySelectorAll('.size-guide__table td[data-cm]');

        this.unitButtons.forEach((button) => {
          button.addEventListener('click', () => {
            this.unitButtons.forEach((otherButton) => {
              otherButton.classList.remove('is-active');
              otherButton.setAttribute('aria-pressed', 'false');
            });
            button.classList.add('is-active');
            button.setAttribute('aria-pressed', 'true');
            this.setUnit(button.dataset.unit);
          });
        });
      }

      setUnit(unit) {
        this.measurementCells.forEach((cell) => {
          const [min, max] = cell.dataset.cm.split('-').map(Number);
          if (unit === 'in') {
            const toInches = (value) => Math.round((value / 2.54) * 10) / 10;
            cell.textContent = `${toInches(min)}-${toInches(max)}`;
          } else {
            cell.textContent = `${min}-${max}`;
          }
        });

        this.querySelectorAll('.size-guide__unit-label').forEach((label) => {
          label.textContent = unit === 'in' ? '(in)' : '(cm)';
        });
      }

      initBuyBox() {
        this.priceCompare = this.querySelector('.size-guide__price-compare');
        this.priceCurrent = this.querySelector('.size-guide__price-current');
        this.productImage = this.querySelector('.size-guide__product-image');
        this.stockWarning = this.querySelector('.size-guide__stock-warning');
        this.buyButtonsWrapper = this.querySelector('[id^="SizeGuideBuyButtons-"]');
        this.variantIdInput = this.buyButtonsWrapper?.querySelector('input[name="id"]');
        this.submitButton = this.buyButtonsWrapper?.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector('span');

        const iconTemplate = this.querySelector('template[id^="SizeGuideCartIcon-"]');
        if (this.submitButton && iconTemplate && !this.submitButton.querySelector('.size-guide__cart-icon')) {
          const iconWrapper = document.createElement('span');
          iconWrapper.className = 'svg-wrapper size-guide__cart-icon';
          iconWrapper.appendChild(iconTemplate.content.cloneNode(true));
          this.submitButton.prepend(iconWrapper);
        }
      }

      initSizeButtons() {
        this.sizeButtons = this.querySelectorAll('.size-guide__size-button');

        this.sizeButtons.forEach((button) => {
          button.addEventListener('click', () => {
            const variant = this.findVariantByOption(button.dataset.value);
            if (!variant) return;

            this.sizeButtons.forEach((otherButton) => otherButton.classList.remove('is-active'));
            button.classList.add('is-active');

            this.selectVariant(variant);
          });
        });
      }

      findVariantById(id) {
        if (!id) return null;
        return this.variants.find((variant) => String(variant.id) === String(id)) || null;
      }

      findVariantByOption(value) {
        const optionKey = `option${this.optionPosition}`;
        return (
          this.variants.find((variant) => {
            if (variant[optionKey] !== value) return false;
            if (!this.currentVariant) return true;
            return ['option1', 'option2', 'option3']
              .filter((key) => key !== optionKey)
              .every((key) => variant[key] === this.currentVariant[key]);
          }) || null
        );
      }

      selectVariant(variant) {
        this.currentVariant = variant;

        if (this.variantIdInput) this.variantIdInput.value = variant.id;

        if (this.priceCurrent) this.priceCurrent.textContent = variant.price;
        if (this.priceCompare) {
          if (variant.onSale) {
            this.priceCompare.textContent = variant.compareAtPrice;
            this.priceCompare.hidden = false;
          } else {
            this.priceCompare.hidden = true;
          }
        }

        if (this.productImage && variant.featuredImage) {
          this.productImage.src = variant.featuredImage;
        }

        if (this.submitButton) {
          this.submitButton.disabled = !variant.available;
          if (this.submitButtonText) {
            this.submitButtonText.textContent = variant.available
              ? this.dataset.addToCartText
              : this.dataset.soldOutText;
          }
        }

        if (this.stockWarning) {
          const lowStock =
            variant.inventoryManagement === 'shopify' &&
            variant.inventoryQuantity > 0 &&
            variant.inventoryQuantity < 10;
          this.stockWarning.hidden = !lowStock;
          this.stockWarning.textContent = lowStock ? `¡Solo quedan ${variant.inventoryQuantity} unidades!` : '';
        }
      }
    }
  );
}
